module.exports = __webpack_public_path__ + "static/media/icon3.2b078693.jpg";